import Contest from '../../Contest';

export default function contestExecutor(options, done) {
	log('Notifications.doContest');
	Screen.changeMode('contest');
	Contest.start(options, done);
}
